export {
  InteractiveView
};

/**
 * @todo Measure load time
 * @todo Add loading timeout, trigger an error.
 * @param {{src: string}}
 * @return {*|{hide(): this, getWindow(): Window, show(): this, mount(*): this}|WindowProxy}
 * @constructor
 */
function InteractiveView({ src, container }){
  const iframe = createIframe(src);
  container.appendChild(iframe);

  return {
    get window(){
      if (process.env.NODE_ENV === 'test') {
        return global.window;
      }
      return iframe.contentWindow;
    },
    get frame(){
      return iframe;
    },
    hide(){
      iframe.style.display = "none";
      return this;
    },
    show() {
      iframe.style.display = "initial";
      return this;
    }
  };
}

function createIframe (pUrl) {
  const frameAttributes = {
    id: "mggp-interactive-iframe",
    name: 'megogo-interactive',
    allowTransparency: true,
    scrolling: "no",
    frameBorder: "0",
    src: pUrl,
  };

  const style = {
    width: "100%",
    height: "100%",
    zIndex: "1",
    display: "none"
  };
  const iframe = document.createElement('iframe');

  Object.assign(iframe, frameAttributes);
  Object.assign(iframe.style, style);

  return iframe;
}
